<template>
  <div>
    <headers></headers>
    <div class="padding250">
      <p class="title">学分认定</p>
      <div class="auto">
        <ul>
          <li><img src="../../assets/success.png" alt=""></li>
          <li>学分认定已提交请等待审核</li>
        </ul>
        <router-link to="/">确定</router-link>

      </div>

    </div>

     <footers></footers>
  </div>
</template>

<script type="text/ecmascript-6">
  import headers from '../template/header'
  import footers from '../template/footer'
  export default {
    name: '',
    props: {},
    data() {
      return {
        formValidate: {
          radio: 'yes'
        }
      };
    },
    methods: {},
    created() {

    },
   components: {
     headers,
     footers
   }
  }
</script>


<style scoped lang="less" rel="stylesheet/less">
  .title{
    font-size: 26px;
    color: #000;
    width: 1200px;
    margin: 30px auto;
    text-align: left;
  }
  .auto{
    background: #fff;
    margin-top: 30px;
    padding: 40px 0 100px;

  }
  ul{
    text-align: center;
    padding: 120px 0 30px;
    li:nth-child(2){
      font-size: 26px;
      color: #999;
      margin: 30px 0;
    }

  }
  a{
    display: block;
    border-radius: 5px;
    background-color: #0A3C68;
    font-size: 18px;
    color: #fff;

    width: 220px;
    height: 50px;
    line-height: 50px;
    text-align: center;
    margin:100px  auto 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/changeScore/rendingsuccess.vue